import { useEffect } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksTraits } from '@olagg/api-hooks';
import TraitForm from './Form';
import { CreateCardDeckTraitData } from '@olagg/db-types';
import { Center, VStack, Spinner, Heading } from '@chakra-ui/react';

export const EditTrait = () => {
  const navigate = useNavigate();
  const { deck_id, id } = useParams();

  if (!deck_id || !id) return null

  const { updateTrait, find, trait, isLoading } = useAdminCardDecksTraits(deck_id);
  
  useEffect(() => {
    if (id) find(id);
  }, [id]);

  if (isLoading) return <Spinner>Cargando...</Spinner>

  const handleSubmit = async (data: CreateCardDeckTraitData) => {
    await updateTrait(id, data);
    navigate(generatePath(ROUTES.CARD_DECKS.traits.all, { deck_id }));
  };

  if (!trait) return null;

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Editar Trait
        </Heading>
        <TraitForm onSubmit={handleSubmit} trait={trait} />
      </VStack>
    </Center>
  );
};
